import Layout from '@/component/Layout/Layout'
import usePollPage from './usePollPage'
import TabBar from '@/ui-components/components/TabBar'
import PageHeader from '@/ui-components/components/PageHeader/PageHeader'
import { useThemeFeatures } from '@/ui-components/hooks/useThemeFeatures'

const PollPage = () => {
  const {
    title,
    onBackAction,
    tabs,
    activeTab,
    handleTabChange,
    renderContent,
  } = usePollPage()
  const themeFeatures = useThemeFeatures()
  return (
    <Layout>
      <div className="flex flex-col items-center w-full">
        <PageHeader title={title} onBack={onBackAction} />
        <div
          className={`w-full px-0 md:px-4 flex items-center ${themeFeatures.ticketAlignLeft ? 'justify-start' : 'justify-center'}`}
        >
          <TabBar
            tabs={tabs}
            activeTab={activeTab}
            onChange={handleTabChange}
            variant="default"
            size="sm"
            fullWidth={false}
          />
        </div>
        {renderContent()}
      </div>
    </Layout>
  )
}
export default PollPage
